export default __webpack_public_path__ + "static/media/gallery_00.185e7e5f.jpg";